module.exports = __webpack_public_path__ + "img/3_64.2607d569.png";